import React from 'react';
import MaskedInput, { conformToMask } from 'react-text-mask';
import mask from '../utils/mask';

export const CEP_MASK = mask([/\d/, 5], '-', [/\d/, 3]);

export function conform(data) {
  return conformToMask(data, CEP_MASK).conformedValue;
}

export default function CEPInput(props) {
  const { inputRef, mask = CEP_MASK, ...rest } = props;

  return <MaskedInput {...rest} ref={inputRef} mask={mask} />;
}
